import { useEffect } from "react";
import styled from "styled-components";

import { API_CALLS } from "../../../API/api_calls";
import { FlexRow } from "../../Common/Styles";
import { CenterPanel } from "./CenterPanel";
import { LeftPanel } from "./LeftPanel";
import { RightPanel } from "./RightPanel";

export const Home = () => {
  useEffect(() => {
    API_CALLS.POST_REACTIONS.getSystemCuratedReactionTypes();
  }, []);

  return (
    <Container>
      <LeftPanel />
      <CenterPanel />
      <RightPanel />
    </Container>
  );
};

const Container = styled(FlexRow)`
  padding: ${({ theme }) => theme.spacing["spacing-8"].value}rem
    ${({ theme }) => theme.spacing["spacing-5"].value}rem;
  gap: ${({ theme }) => theme.spacing["spacing-7"].value}rem;
`;
